import { render, staticRenderFns } from "./_base-due-date-picker.vue?vue&type=template&id=4c222a34&scoped=true&"
import script from "./_base-due-date-picker.vue?vue&type=script&lang=js&"
export * from "./_base-due-date-picker.vue?vue&type=script&lang=js&"
import style0 from "./_base-due-date-picker.vue?vue&type=style&index=0&id=4c222a34&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c222a34",
  null
  
)

export default component.exports